"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOWEST_PREVIOUS_PRICE = void 0;
const LOWEST_PREVIOUS_PRICE = exports.LOWEST_PREVIOUS_PRICE = 'LowestPreviousPrice';
